import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";

import { saveClient, saveIdToken } from "../../utils/storage";
import { signup, authMethod } from "../../services/authNew";

const Signup = (props) => {
  const { setToast } = props;

  const [signupData, setSignupData] = useState({
    firstName: "",
    lastName: "",
    identifier: "",
    password: "",
    organizationName: "",
    authMethodId: 1, // Initialize with null or an empty string
  });
  const [areRequiredFieldsCompleted, setAreRequiredFieldsCompleted] =
    useState(false);
  const [isCreatingClient, setIsCreatingClient] = useState(false);
  const [isCreatedClient, setIsCreatedClient] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleAreRequiredFieldsCompleted = () => {
    const { firstName, lastName, identifier, password, organizationName } =
      signupData;
    // Check if the required fields are completed
    if (firstName && lastName && identifier && password && organizationName) {
      setAreRequiredFieldsCompleted(true);
    } else {
      setAreRequiredFieldsCompleted(false);
    }
  };

  const handleChange = (event) => {
    setSignupData({ ...signupData, [event.target.name]: event.target.value });
  };

  // async function addSMEClient(clientData) {
  //   try {
  //     const result = await axios.post(
  //       `${process.env.REACT_APP_API_BASE_URL}/versus_v2_add_sme_client`,
  //       clientData,
  //       { headers: { "content-type": "application/json" } }
  //     );
  //     setIsCreatingClient(false);
  //     const client = result.data.client;
  //     saveClient(client);

  //     if (result.status === 200) {
  //       setIsCreatedClient(true);
  //     } else {
  //       setToast({
  //         show: true,
  //         type: "danger",
  //         message: "Failed to add new client",
  //       });
  //     }
  //   } catch (error) {
  //     setIsCreatingClient(false);
  //     console.log("Error adding new client", error);
  //     setToast({
  //       show: true,
  //       type: "danger",
  //       message: "Failed to add new client",
  //     });
  //   }
  // }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsCreatingClient(true);

    try {
      const signupResponse = await signup(signupData);
      console.log("signupResponse", signupResponse.token);

      saveIdToken(signupResponse.token);
      saveClient(signupResponse);

      if (signupResponse?.success === true) {
        setIsCreatedClient(true);
      } else {
        setIsCreatingClient(false);
        setToast({
          show: true,
          type: "danger",
          message: "Signup was not successful. Please try again.",
        });
      }
    } catch (error) {
      setIsCreatingClient(false);
      console.error("Signup failed", error);
      setToast({
        show: true,
        type: "danger",
        message: "Signup failed. Please try again.",
      });
    }
  };
  useEffect(() => {
    const getAuthMethod = async () => {
      try {
        const { data } = await authMethod();
        const authenticationMethod = data?.data.find(
          ({ method }) => method === "email"
        );

        if (authenticationMethod) {
          // Use a function to update state to ensure you have the latest state
          setSignupData((prevData) => ({
            ...prevData,
            authMethodId: authenticationMethod.id,
          }));
        }
      } catch (error) {
        console.error("Error fetching Auth Method", error);
      }
    };
    getAuthMethod();
  }, []);

  useEffect(() => {
    handleAreRequiredFieldsCompleted();
  }, [signupData]);

  if (isCreatedClient) {
    return <Redirect to="/subscribe" />;
  }

  return (
    <div className="sign-up" style={{ padding: "0px" }}>
      <div>
        <div className="form-block w-form">
          <form onSubmit={handleSubmit}>
            {/* Form fields... */}
            <div className="control throw-down">
              <label>First names</label>
              <input
                type="text"
                className="input large w-input"
                maxLength="256"
                name="firstName"
                onChange={handleChange}
                required
              />
            </div>
            <div className="control">
              <label>Last name</label>
              <input
                type="text"
                className="input large w-input"
                maxLength="256"
                name="lastName"
                onChange={handleChange}
                required
              />
            </div>
            <div className="control">
              <label>Email</label>
              <input
                type="identifier"
                className="input large w-input"
                maxLength="256"
                name="identifier"
                onChange={handleChange}
                required
              />
            </div>
            <div className="control">
              <label>Password</label>
              <input
                type={showPassword ? "text" : "password"}
                className="input large w-input"
                maxLength="256"
                name="password"
                onChange={handleChange}
                required
              />
            </div>
            <div className="control">
              <label>Organization Name</label>
              <input
                type="text"
                className="input large w-input"
                maxLength="256"
                name="organizationName"
                onChange={handleChange}
                required
              />
            </div>
            {/* The rest of your form, button, and links */}
            {isCreatingClient ? (
              <button className="button is-disabled large wide w-button">
                Creating client...
              </button>
            ) : !areRequiredFieldsCompleted ? (
              <button className="button is-disabled large wide w-button">
                Sign up now
              </button>
            ) : (
              <button
                className="button primary large wide w-button"
                onClick={handleSubmit}
              >
                Sign up now
              </button>
            )}
          </form>
          <div style={{ textAlign: "center" }}>
            Already have an account? <Link to="/login">Log in.</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
